export default "__VITE_ASSET__DcG5oAcE__"